{
    "Skjema.input.dato.placeholder": "dd.mm.åååå"
}
